import { Decimal } from 'decimal.js-light';

export const DECIMAL_ZERO = new Decimal(0);
export const DECIMAL_ONE = new Decimal(1);

export const DECIMAL_PLACES = 2;
export const MAX_TRILLION = 9_999_999_999_999;
